/** The hardware-first checkout is the only checkout; all pricing comes from the server. */
export default function useHardwareFirstCheckout(): boolean {
  return true;
}
